import { findKey } from 'lodash';
import {
  ChatStarterKindSnakeType,
  UIFilterStarterKindType,
} from '../model/ChatStarterModel';
import { LinkTypes } from '../model/PromoterModel';

const map: Record<
  Exclude<ChatStarterKindSnakeType, 'getemails'>,
  UIFilterStarterKindType
> = {
  all: 'all',
  fb_comment_guard: 'comment_guard',
  customer_chat: 'customer_chat_widget',
  link: 'share_links',
  instagram_link: 'instagram_link',
  send_to_messenger: 'facebook_optin',
  checkbox: 'facebook_optin',
  welcome_page: 'facebook_page_welcomer',
  landing_page: 'landing_pages',
  optin: 'optin_popups',
  sms_keywords: 'sms_keywords',
  instagram_welcomer: 'instagram_welcomer',
  instagram_story_mention: 'instagram_story_mention',
  instagram_story_reaction: 'instagram_story_reaction',
  instagram_comment_guard: 'instagram_comment_guard',
  instagram_live_comment_guard: 'instagram_live_comment_guard',
  instagram_catch_all: 'instagram_catch_all',
  facebook_catch_all: 'facebook_catch_all',
};

export const helpLinks: Record<LinkTypes, string> = {
  fb_comment_guard:
    'https://customers.ai/help/article/xcr08txqxa-post-comment-guard-video',
  customer_chat:
    'https://customers.ai/help/article/j2eu4z7iah-website-chat-widget',
  optin: 'https://customers.ai/help/article/0fah7phh3c-sms-popups',
  link: 'https://customers.ai/help/article/9elggt28na-share-links',
  instagram_link: '',
  checkbox: '',
  send_to_messenger: '',
  instagram_welcomer: '',
  instagram_story_mention: '',
  instagram_comment_guard: '',
  instagram_story_reaction: '',
  sms_keywords: '',
  instagram_live_comment_guard: '',
  instagram_catch_all: '',
  facebook_catch_all: '',
  getemails: '',
};

export const mapPromoterLinkTypeToUIFilterKind = (type: LinkTypes) => {
  return mapChatStarterKindToUIFilterKind(type as ChatStarterKindSnakeType);
};

export const mapChatStarterKindToUIFilterKind = (
  kind: ChatStarterKindSnakeType,
): UIFilterStarterKindType => map[kind];

export const mapUIFilterKindToChatStarterKind = (
  kind: UIFilterStarterKindType,
) => {
  const match = findKey(map, v => v === kind);
  return match ? (match as ChatStarterKindSnakeType) : undefined;
};
